module.exports = __webpack_public_path__ + "img/19_Lower-rectrum.b8f762ff.png";